<template>
  <div>
    <header-page showCiudadSelector :form_dirty="form_dirty" @update="init()"  />
    <div class="container">
      <Breadcrumbs />
      <div class="divBtn">
        <q-btn
          unelevated
          class="bPrincipal"
          @click="goToVistaGeneral"
        >VISTA GENERAL</q-btn>
      </div>
      <q-card>
        <h5 class="titleCard">Plan de Acción</h5>
        <h2 class="subTitleCard marginTop">Objetivos estratégicos</h2>
        <ListadoObjetivos v-if="arrayObjetivos && arrayObjetivos.length > 0" :arrayObjetivos="arrayObjetivos" />
      </q-card>
      <DialogWarning
        v-model="showDialog"
        dataCy="delete-indicador"
        :showIcon="true"
        :txtContainer="
          `Los datos introducidos no han sido guardados. Si abandona el proceso sin guardar se perderán todos los cambios.¿Desea salir del indicador?`
        "
        labelDelete="SÍ, SALIR Y PERDER TODOS LOS CAMBIOS"
        labelCancel="NO, PERMANECER EN EL INDICADOR"
        @save="saveChanges()"
      />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import HeaderPage from '@/components/shared/HeaderPage.vue';
import ListadoObjetivos from '@/components/PlanAccion/components/ListadoObjetivos.vue';
import * as types from '@/storeModules/NGUD/types';
import DialogWarning from '@/shared/dialogs/warning/DialogWarning.vue';

export default {
  components: {
    Breadcrumbs,
    HeaderPage,
    ListadoObjetivos,
    DialogWarning
  },
  async created () {
    await this.$store.dispatch(types.ACTION_GET_ALL_AUEOBJETIVES).then(response => {
      this.arrayObjetivos = response.data;
    }).catch();

    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },
  data: function () {
    return {
      arrayObjetivos: null,
      form_dirty: false,
      showDialog: false,
      to: null
    };
  },
  beforeRouteLeave (to, from, next) {
    if (!this.form_dirty) {
      next();
    } else {
      this.to = to;
      this.showDialog = true;
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (!this.form_dirty) {
      next();
    } else {
      this.to = to;
      this.showDialog = true;
    }
  },
  mounted () {
    this.$eventHub.$on('dirtyForm', acciones => {
      this.form_dirty = true;
    });
    this.$eventHub.$on('cleanForm', acciones => {
      this.form_dirty = false;
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('dirtyForm');
    this.$eventHub.$off('cleanForm');
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
  methods: {
    closeDialog () {
      this.showDialog = false;
      this.form_dirty = true;
      this.to = null;
    },
    saveChanges () {
      this.showDialog = false;
      this.form_dirty = false;
      this.$router.push(this.to.path);
    },
    beforeWindowUnload (e) {
      if (this.form_dirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
    init () {
      location.reload();
    },
    goToVistaGeneral () {
      this.$router.push({
        name: 'plan-accion/vista-general'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.marginTop {
  margin-top: 20px;
}
.divBtn{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}
</style>
